<template>
<div class="container-accountResetPwd">
    <!-- <mt-header title="设置">
      <router-link to="/" slot="left">
        <mt-button icon="back">返回</mt-button>
        </router-link>
    </mt-header> -->
    <div class="accountResetPwd">.
        <div class="wrap-way" @click="reset">
            验证身份证和短信来重置支付密码
            <span class="el-rt">
                <i class="icon-arrow-rt"></i>
            </span>
        </div>
        <div class="wrap-way" @click="change">
            记得原支付密码，想修改新支付密码
            <span class="el-rt">
                <i class="icon-arrow-rt"></i>
            </span>
        </div>
    </div>
</div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
import {Get,Post} from '@/utils/http';
export default {
  name: 'Setting',
  data () {
    return {
        wallet_id:'',
    }
  },
  mounted() {
    this.wallet_id = this.$route.params.wallet_id;
  },
   methods: {

    openSelectBox() {
    //    this.showBox = true;
    },
    reset(){
        const url = '/v1/person/wallet/password/reset';
        const params = {
            wallet_id:  this.wallet_id,
            redirect:   `${window.location.origin}${window.location.pathname}#/`,
        }
        Indicator.open();
        Post(url,params).then((res)=>{
            Indicator.close();
            window.location = res.pwd_reset_url;
        }).catch((error)=>{
            Indicator.close();
            Toast({
                message: "code:"+error.code+" message:"+error.msg,
                duration: 3000
            });
        })
    },
    change(){
        const url = '/v1/person/wallet/password/change';
        const params = {
            wallet_id:  this.wallet_id,
            redirect:   `${window.location.origin}${window.location.pathname}#/`,
        }
        Indicator.open();
        Post(url,params).then((res)=>{
            Indicator.close();
            window.location = res.pwd_change_url;
        }).catch((error)=>{
            Indicator.close();
            Toast({
                message: "code:"+error.code+" message:"+error.msg,
                duration: 3000
            });
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.container-accountResetPwd {
    .accountResetPwd {
        padding: 0 .15rem;
        text-align: left;
    }
    .accountResetPwd .notice {
        color: #66748a;
        padding: .1rem 0;
    }
    .wrap-way {
        background: #fff;
        position: relative;
        width: 100%;
        height: .6rem;
        color: #373c43;
        padding: 0 .15rem;
        line-height: .6rem;
    }
    .wrap-way .el-rt {
        display: inline-block;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        transform: translateY(-50%);
        right: .15rem;
    }
    .wrap-way+.wrap-way {
        margin-top: 5px;
    }
    .icon-arrow-rt{
    display: inline-block;
    font-size: 12px;
    background: url('../assets/rightArrow.png') no-repeat;
    width: .15rem;
    height: .15rem;
    background-size: contain;
    margin-bottom: -0.02rem;
    margin-left: 0.02rem;
    }
    .wrap-way .el-rt .icon-arrow-rt {
        color: #373c43;
    }
    .wrap-way:after {
        content: "";
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        height: 300%;
        width: 300%;
        pointer-events: none;
        -webkit-transform: scale(.33333);
        -moz-transform: scale(.33333);
        transform: scale(.33333);
        -webkit-transform-origin: 0 0;
        -moz-transform-origin: 0 0;
        transform-origin: 0 0;
        border: 1px solid #f4f4f4;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        -o-border-radius: 12px;
        border-radius: 12px;
    }

    .mint-header {
        // height: 24px;
        background: white;
        color: #222;
        // margin-bottom: 1em;

        .is-left .mint-button {
        text-align: left;
        color: #41a3ff;
        border: none;
        }
        .is-right .mint-button {
        text-align: right;
        color: #41a3ff;
        border: none;
        }
    }
    .mint-header-title {
        font-size:    18px;
        font-weight:  bold;
    }

    .mint-cell+.mint-cell {
        .mint-cell-wrapper {
        border-top:   1px solid #999;
        }
    }
}


</style>



// WEBPACK FOOTER //
// src/views/Setting.vue